import { render } from "./CandleAnimation.vue?vue&type=template&id=07b10bd0&scoped=true"
import script from "./CandleAnimation.vue?vue&type=script&lang=js"
export * from "./CandleAnimation.vue?vue&type=script&lang=js"

import "./CandleAnimation.vue?vue&type=style&index=0&id=07b10bd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b10bd0"]])

export default __exports__